module.exports = __webpack_public_path__ + "media/CreditsBanner.d4633ef0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/credits/CreditsBanner.jpg
// module id = 1084
// module chunks = 0